import styled from "styled-components";

const Title = styled.div`
    font-size: 24px;
    font-weight: bold;
    color: inherit;
`

export default Title;